module.exports = {
    "breadcrumbs": `Morzsamen\xfc`
};


//# sourceMappingURL=hu-HU.main.js.map
